// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jFcXT{width:260px;flex-shrink:0}.jFcXT.B1ECZ{width:100% !important;max-width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"autocomplete": `jFcXT`,
	"autocompleteMobile": `B1ECZ`
};
export default ___CSS_LOADER_EXPORT___;
